module.exports = __webpack_public_path__ + "img/join_us_wrap.88226f9.88226f9b.png";